import * as Sentry from "@sentry/react";
import { AssessmentQuestion } from "./questionTypes";
import { welcomeQuestion, completionQuestion, ownerReadinessExitTimelineWelcome, ownerReadinessCompletionQuestion, businessProfileCompletionQuestion } from "./questions/welcomeAndCompletion";
import { levelSetQuestion } from "./questions/levelSetQuestion";
import { snapshotAssessmentQuestionsWithCompletion } from "./questions/snapshotAssessmentQuestions";
import { ownerReadinessQuestions } from "./questions/ownerReadinessQuestions";
import { businessProfileQuestions } from "./questions/businessProfileQuestions";
import { logger } from '@/utils/logger';

// Get questions based on current module
export function getAssessmentQuestions(moduleId?: string): AssessmentQuestion[] {
  logger.debug('getAssessmentQuestions called with moduleId:', moduleId);
  
  // Validate moduleId and provide safe fallback
  if (moduleId && typeof moduleId !== 'string') {
    Sentry.captureException(new Error('Invalid moduleId type'), {
      tags: { context: 'validation_error', component: 'assessmentQuestions' },
      extra: { message: 'Invalid moduleId type', moduleIdType: typeof moduleId, moduleId }
    });
    moduleId = undefined;
  }
  
  switch (moduleId) {
    case "owner-readiness-exit-timeline":
      const exitTimelineQuestions = [
        // Owner Readiness Exit Timeline Welcome Screen
        ownerReadinessExitTimelineWelcome,
        
        // Owner Readiness Questions (excluding the original welcome)
        ...ownerReadinessQuestions.filter(q => q.id !== "owner-readiness-welcome"),
        
        // Owner Readiness Completion Screen
        ownerReadinessCompletionQuestion
      ];
      logger.debug('Returning exit timeline questions:', exitTimelineQuestions.length);
      return exitTimelineQuestions;
      
    case "business-profile":
      const businessProfileWithCompletion = [
        ...businessProfileQuestions.slice(0, -1), // All questions except the last completion
        businessProfileCompletionQuestion // Use the specific business profile completion
      ];
      logger.debug('Returning business profile questions:', businessProfileWithCompletion.length);
      return businessProfileWithCompletion;
    case "owner-readiness":
    default:
      return [
        // Welcome Screen
        welcomeQuestion,
        
        // Level Set Screen
        levelSetQuestion,
        
        // Snapshot Assessment Questions with mySuccession Completion
        ...snapshotAssessmentQuestionsWithCompletion
      ];
  }
}

// Default export for backward compatibility
export const assessmentQuestions: AssessmentQuestion[] = getAssessmentQuestions();
